module.exports = __webpack_public_path__ + "static/database-40b8d2d965201ceedfe60a62b58f4934.png";